module.exports = __webpack_public_path__ + "static/media/image_57.69bbeda9.png";